import { useParams } from "react-router-dom";

export const useQuarterId = () => {
  const params = useParams();
  if(params.qtrId) {
    return params.qtrId;
  } 
  return 'public'
}